import { Link, useNavigate } from "react-router-dom";
import { Users, Briefcase, Fuel, Cog, Snowflake, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { segmentLabel } from "@/lib/site";
import { useSettings } from "@/context/SettingsContext";

export default function VehicleCard({ vehicle, index = 0, onBook }) {
  const navigate = useNavigate();
  const { settings } = useSettings();
  const hasImage = (vehicle.images || []).length > 0;
  const specs = [
    { icon: Cog, label: "Otomatik" },
    { icon: Fuel, label: vehicle.fuel === "benzin" ? "Benzin" : vehicle.fuel === "dizel" ? "Dizel" : "Hibrit" },
    { icon: Users, label: `${vehicle.seats} Kişilik` },
    { icon: Briefcase, label: `${vehicle.luggage} Bagaj` },
  ];

  return (
    <div
      data-testid={`vehicle-card-${vehicle.slug}`}
      className="group bg-white rounded-2xl border border-neutral-200 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300 overflow-hidden flex flex-col"
    >
      <div className="relative aspect-[16/10] overflow-hidden bg-neutral-100">
        {hasImage && (
          <img
            src={vehicle.images[0]}
            alt={vehicle.name}
            loading="lazy"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        )}
        <Badge className="absolute top-3 left-3 bg-[#A11016] hover:bg-[#A11016] text-white border-0">{segmentLabel(vehicle.segment)}</Badge>
        {vehicle.ac && (
          <span className="absolute top-3 right-3 bg-white/90 backdrop-blur px-2 py-1 rounded-md text-xs font-medium text-neutral-700 flex items-center gap-1">
            <Snowflake className="h-3 w-3 text-[#A11016]" /> Klima
          </span>
        )}
      </div>

      <div className="p-5 flex flex-col flex-1">
        <div className="mb-1 text-xs font-medium uppercase tracking-wider text-neutral-400">{vehicle.brand}</div>
        <h3 className="text-lg font-bold text-[#171717]">{vehicle.name}</h3>

        <div className="grid grid-cols-2 gap-2 mt-4 mb-5">
          {specs.map((s, i) => (
            <div key={i} className="flex items-center gap-2 text-sm text-neutral-600">
              <s.icon className="h-4 w-4 text-[#A11016]" />
              <span>{s.label}</span>
            </div>
          ))}
        </div>

        <div className="mt-auto">
          <div className="flex items-center justify-between mb-4">
            <a
              href={`tel:${settings.phone_link}`}
              data-testid={`vehicle-call-price-${vehicle.slug}`}
              className="flex items-center gap-1.5 text-sm font-semibold text-[#A11016] hover:text-[#820D12] transition-colors"
            >
              <Phone className="h-4 w-4" /> Fiyat için arayın
            </a>
            <span className="text-[11px] text-neutral-400">Araç veya benzeri</span>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <Button
              variant="outline"
              className="border-neutral-300 text-[#171717] hover:bg-neutral-100"
              onClick={() => navigate(`/araclar/${vehicle.slug}`)}
              data-testid={`vehicle-detail-button-${vehicle.slug}`}
            >
              Detayları İncele
            </Button>
            <Button
              className="bg-[#A11016] hover:bg-[#820D12] text-white"
              onClick={() => (onBook ? onBook(vehicle) : navigate(`/araclar/${vehicle.slug}`))}
              data-testid={`vehicle-book-button-${vehicle.slug}`}
            >
              Hemen Kirala
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
